import { Controller } from "@hotwired/stimulus"

// Drives the shared "Save to your game" dialog. Each card's Save button
// (data-action="area-picker#open") points at the picker path; we load it into
// the frame and open the native <dialog>. The picker form closes the dialog on
// a successful submit (turbo:submit-end).
export default class extends Controller {
  static targets = ["dialog", "frame"]

  open(event) {
    event.preventDefault()
    // Force a fresh load every open so the checkboxes reflect current state,
    // even when re-opening the same video.
    this.frameTarget.src = event.currentTarget.href
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  onSubmitEnd(event) {
    if (event.detail.success) this.close()
  }

  // Native <dialog> click covers the whole viewport; treat a click on the
  // backdrop (outside the panel) as a request to close.
  backdropClose(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  // Drop the src on close so re-opening the same video always re-fetches fresh
  // checkbox state rather than reusing the already-loaded frame.
  onClose() {
    this.frameTarget.removeAttribute("src")
  }
}
